import { combineEpics } from 'redux-observable'
import { messageEpic } from './MessageEpic.js'
import { LoadSystemMessagesEpic } from './LoadSystemMessagesEpic.js'

export const messageEpics = combineEpics(messageEpic, LoadSystemMessagesEpic)
